import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { toast } from "sonner";
import { useSeo } from "@/hooks/useSeo";

export default function Login() {
  useSeo({ title: "Connexion", description: "Connectez-vous à votre espace R-1.immo pour gérer vos annonces de sous-sols, vos favoris et vos demandes reçues.", path: "/login" });
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [err, setErr] = useState("");
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const nav = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setErr("");
    const r = await login(email, password);
    setLoading(false);
    if (r.ok) {
      toast.success("Bienvenue");
      nav("/dashboard");
    } else {
      setErr(r.error);
    }
  };

  return (
    <div className="min-h-[80vh] px-6 md:px-12 lg:px-16 py-16 flex flex-col items-center justify-center">
      <div className="w-full max-w-md border border-zinc-800 bg-zinc-950 p-8">
        <div className="label-mono mb-2 text-amber-500">§ connexion</div>
        <h1 className="font-display text-3xl mb-8">Accéder à votre espace</h1>

        <form onSubmit={submit} className="space-y-4">
          <div>
            <label className="label-mono block mb-2">Email</label>
            <input required type="email" value={email} onChange={(e) => setEmail(e.target.value)} data-testid="login-email" className="w-full bg-zinc-900 border border-zinc-800 px-3 py-3 text-sm focus:outline-none focus:border-amber-500" />
          </div>
          <div>
            <label className="label-mono block mb-2">Mot de passe</label>
            <input required type="password" value={password} onChange={(e) => setPassword(e.target.value)} data-testid="login-password" className="w-full bg-zinc-900 border border-zinc-800 px-3 py-3 text-sm focus:outline-none focus:border-amber-500" />
          </div>
          {err && <div className="text-sm text-red-400 label-mono" data-testid="login-error">{err}</div>}
          <button type="submit" disabled={loading} data-testid="login-submit" className="w-full bg-amber-500 hover:bg-amber-400 disabled:opacity-50 text-black py-3 text-xs uppercase tracking-widest transition-colors">
            {loading ? "Connexion…" : "Se connecter"}
          </button>
        </form>

        <div className="mt-8 pt-6 border-t border-zinc-800 text-sm text-zinc-400 text-center">
          Pas encore de compte ? <Link to="/register" className="text-amber-500">Créer un compte</Link>
        </div>
      </div>
      <div className="w-full max-w-md mt-10 text-sm text-zinc-500 leading-relaxed space-y-3">
        <p><strong className="text-zinc-300">Votre espace R-1.immo</strong> regroupe vos annonces de sous-sols en cours de validation ou publiées, les demandes de visite reçues, vos favoris et vos alertes personnalisées. Propriétaires et exploitants gèrent leur activité depuis un tableau de bord unique.</p>
        <p>Nouveau sur la marketplace des m² invisibles ? Créez votre compte en 30 secondes et publiez votre premier sous-sol, cave, parking ou local atypique. Notre équipe valide chaque annonce sous 48 h pour garantir la qualité du catalogue.</p>
      </div>
    </div>
  );
}
